import React, { useEffect, useState } from 'react';

const BreathingAnimation = ({ phase, duration, isActive }) => {
  const [scale, setScale] = useState(0.7);
  const [opacity, setOpacity] = useState(0.2);
  const [haloIntensity, setHaloIntensity] = useState(0.3); // For progressive halo

  useEffect(() => {
    if (!isActive) {
      setScale(0.7);
      setOpacity(0.2);
      setHaloIntensity(0.3);
      return;
    }


    // Animation basée sur la phase - Taille optimisée avec halo progressif
    if (phase === 'inhale') {
      // Cercle GRANDIT + Halo intensifie progressivement
      setScale(1.4);
      setOpacity(0.8);
      setHaloIntensity(1.0); // Halo maximum
    } else if (phase === 'hold1' || phase === 'hold2') {
      // Cercle reste STABLE + Halo stable
      setScale(1.4);
      setOpacity(0.8);
      setHaloIntensity(0.9);
    } else if (phase === 'exhale') {
      // Cercle RÉTRÉCIT + Halo diminue progressivement
      setScale(0.75);
      setOpacity(0.3);
      setHaloIntensity(0.4); // Halo minimum
    }
  }, [phase, isActive]);

  return (
    <div className="relative flex items-center justify-center w-full" style={{ height: '220px' }}>
      {/* Halo progressif dynamique - Layer 1 (plus lointain) */}
      <div
        className="absolute rounded-full transition-all ease-in-out"
        style={{
          width: `${scale * 220}px`,
          height: `${scale * 220}px`,
          background: `radial-gradient(circle, rgba(111, 66, 234, ${haloIntensity * 0.2}) 0%, rgba(139, 92, 246, ${haloIntensity * 0.12}) 40%, transparent 70%)`,
          filter: 'blur(50px)',
          transitionDuration: duration ? `${duration * 1000}ms` : '2000ms',
          opacity: haloIntensity,
        }}
      />

      {/* Halo progressif dynamique - Layer 2 (moyen) */}
      <div
        className="absolute rounded-full transition-all ease-in-out"
        style={{
          width: `${scale * 190}px`,
          height: `${scale * 190}px`,
          background: `radial-gradient(circle, rgba(111, 66, 234, ${haloIntensity * 0.35}) 0%, rgba(139, 92, 246, ${haloIntensity * 0.2}) 50%, transparent 70%)`,
          filter: 'blur(40px)',
          transitionDuration: duration ? `${duration * 1000}ms` : '2000ms',
          opacity: haloIntensity * 0.9,
        }}
      />

      {/* Halo progressif dynamique - Layer 3 (proche) */}
      <div
        className="absolute rounded-full transition-all ease-in-out"
        style={{
          width: `${scale * 165}px`,
          height: `${scale * 165}px`,
          background: `radial-gradient(circle, rgba(111, 66, 234, ${haloIntensity * 0.5}) 0%, rgba(68, 26, 122, ${haloIntensity * 0.35}) 50%, transparent 70%)`,
          filter: 'blur(30px)',
          transitionDuration: duration ? `${duration * 1000}ms` : '2000ms',
          opacity: haloIntensity * 0.85,
        }}
      />

      {/* Cercle principal - Taille encore plus réduite pour éviter chevauchements */}
      <div
        className="relative rounded-full transition-all ease-in-out"
        style={{
          width: `${scale * 130}px`,
          height: `${scale * 130}px`,
          background: 'linear-gradient(135deg, #6F42EA 0%, #8B5CF6 50%, #441A7A 100%)',
          boxShadow: `0 0 ${scale * 40}px rgba(111, 66, 234, ${opacity * 0.8}), 0 0 ${scale * 65}px rgba(111, 66, 234, ${opacity * 0.4})`,
          transitionDuration: duration ? `${duration * 1000}ms` : '2000ms',
        }}
      >
        {/* Inner glow - Plus visible */}
        <div
          className="absolute inset-0 rounded-full"
          style={{
            background: 'radial-gradient(circle at center, rgba(255, 255, 255, 0.35) 0%, transparent 70%)',
          }}
        />
        
        {/* Rotating shimmer effect inside circle */}
        {isActive && (
          <div
            className="absolute inset-0 rounded-full"
            style={{
              background: 'conic-gradient(from 0deg, transparent 0%, rgba(255, 255, 255, 0.15) 25%, transparent 50%, rgba(255, 255, 255, 0.15) 75%, transparent 100%)',
              animation: 'spin 8s linear infinite',
            }}
          />
        )}
      </div>

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default BreathingAnimation;
